import { TextButton } from '@wix/design-system'
import React, { FC } from 'react'

interface WixMobileSkipButtonProps {
  onSkip: () => void
  dataHook?: string
  label: string
}

export const WixMobileSkipButton: FC<WixMobileSkipButtonProps> = ({ dataHook, onSkip, label }) => {
  return (
    <TextButton skin="dark" onClick={onSkip} dataHook={dataHook}>
      {label}
    </TextButton>
  )
}
